// Regular expression pattern
var regex = /^https?:\/\/[\w\-.]+\/collections\/[\w\-]+\/products\/[\w\-]+$/;

// URL to check
var url = window.location.href;

// Test if the URL matches the regex pattern
if (regex.test(url)) {
    const new_url = url.split("/")
    new_url.splice(3, 2);
    const new_href = new_url.join('/')
    window.location.href = new_href
} else {
    console.log("URL does not match the pattern.");
}